import React from 'react';
import { useTokens } from '@mezzoforte/forge';
import { LoggedInIcon } from '@/components/Header/UserGreeting/LoggedInIcon';
import { Company } from '@/types/Company';

const { colors } = useTokens.huutokaupat;

export interface CompanyIconProps {
  readonly company: Company;
}

export function CompanyIcon({ company }: CompanyIconProps) {
  const initials = company.internalDisplayName
    .toUpperCase()
    .split(' ')
    .map((word) => word[0])
    .join('')
    .substring(0, company.isConsumer ? 2 : 1);

  return (
    <LoggedInIcon
      initials={initials}
      background={company?.isConsumer ? colors.brand : colors.success}
    />
  );
}
